import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import { useState } from 'react';
import PartnerModal from '../PartnerModal';
import gtm from '@/utils/gtm';

const SuperchargeSection = () => {
    const { t } = useLang('theProduct.SuperchargeSection');
    const [modalVisible, setModalVisible] = useState(false);

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751247503423/supercharge-your-solar-section_img1.webp',
            title: t('card1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751247503636/supercharge-your-solar-section_img2.webp',
            title: t('card2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751247503841/supercharge-your-solar-section_img3.webp',
            title: t('card3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751247503189/supercharge-your-solar-section_img4.webp',
            title: t('card4'),
        },
    ];

    const handleClick = () => {
        setModalVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_pre_order',
            product_name: 'EcoFlow Ocean Pro Be the First to Know_Supercharge your solar',
        });
    };
    return (
        <section className={styles.superchargeSection}>
            <div className="text-container">
                <p className="label">{t('label')}</p>
                <h2 className="title">{t('title')}</h2>
                <p className="intro">{t('desc')}</p>
            </div>
            <EcoGraphicSwiper uiType="ui4" imgHeight="5-3" items={list} />
            <div className="btn-container">
                <button className="primary-btn" onClick={handleClick}>
                    {t(`btn`)}
                </button>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </section>
    );
};

export default SuperchargeSection;
